<template>
    <!-- «Хто повільніший»: по черзі кожен чекає піцу й тисне, щойно вона з'явиться; найповільніший платить.
         Натиснув зарано — той самий гравець пробує ще раз -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'done'">Найповільніше — <b>{{ players[loser] }}</b>!</template>
            <template v-else>Черга: <b>{{ players[current] }}</b></template>
        </p>
        <button type="button" class="bp-wp-tap" :class="'is-' + state" :disabled="state == 'done'" @pointerdown.prevent="tap()" @keydown.enter.prevent="tap()" @keydown.space.prevent="tap()">
            <template v-if="state == 'ready'">
                <span class="bp-wp-tap__big">Готові?</span>
                <span class="bp-wp-tap__small">Натисніть, а тоді чекайте піцу й тисніть, щойно з'явиться</span>
            </template>
            <template v-else-if="state == 'wait'">
                <span class="bp-wp-tap__big">Чекаємо…</span>
                <span class="bp-wp-tap__small">Не тисніть, поки немає піци</span>
            </template>
            <template v-else-if="state == 'go'">
                <img v-if="photo" :src="photo" alt="" class="bp-wp-tap__pizza">
                <span class="bp-wp-tap__big">Тисни!</span>
            </template>
            <template v-else-if="state == 'early'">
                <span class="bp-wp-tap__big">Зарано!</span>
                <span class="bp-wp-tap__small">Натисніть, щоб спробувати ще раз</span>
            </template>
            <template v-else-if="state == 'shown'">
                <span class="bp-wp-tap__big">{{ times[last] }} мс</span>
                <span class="bp-wp-tap__small">{{ current != null ? 'Передайте телефон: ' + players[current] : '' }}</span>
            </template>
            <template v-else>
                <span class="bp-wp-tap__big">{{ times[loser] }} мс</span>
            </template>
        </button>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': i == current && state != 'done', 'is-lose': state == 'done' && i == loser }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">{{ times[i] != null ? times[i] + ' мс' : '—' }}</span>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: 'GameReaction',
    props: {
        players: { type: Array, required: true },
        photo: { type: String, default: '' }
    },
    data() {
        return {
            current: 0,
            last: null,
            state: 'ready',
            times: this.players.map(() => null),
            loser: null,
            timer: null,
            start: 0
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        tap() {
            if (this.state == 'ready' || this.state == 'early' || this.state == 'shown') {
                if (this.state == 'shown' && this.current == null) return;
                this.state = 'wait';
                // Піца з'являється через 1,5–4 с — не вгадати
                this.timer = setTimeout(() => {
                    this.state = 'go';
                    this.start = performance.now();
                }, 1500 + Math.random() * 2500);
                return;
            }
            if (this.state == 'wait') {
                clearTimeout(this.timer);
                this.state = 'early';
                return;
            }
            if (this.state == 'go') {
                const ms = Math.round(performance.now() - this.start);
                this.$set(this.times, this.current, ms);
                this.last = this.current;
                const next = this.times.findIndex(t => t == null);
                if (next == -1) {
                    const max = Math.max(...this.times);
                    this.loser = this.times.indexOf(max);
                    this.current = null;
                    this.state = 'done';
                    setTimeout(() => this.$emit('done', { loser: this.loser, note: 'Реакція ' + max + ' мс' }), 1300);
                    return;
                }
                this.current = next;
                this.state = 'shown';
            }
        }
    }
}
</script>
